import React, { useState } from 'react';
import { Box } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { VeniceIcon } from 'components/icons';
import { MapArrowRightIcon } from 'components/icons/map-arrow-right';

export const CoManagerInput = ({ placeholder = 'Ask Venice Assistant anything', InputIcon = MapArrowRightIcon }) => {
  const [inputValue, setInputValue] = useState('');
  const history = useHistory();

  const handleRedirect = () => {
    if (inputValue.trim()) {
      history.push(`/co-manager?prompt=${encodeURIComponent(inputValue)}`);
    }
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      handleRedirect();
    }
  };

  return (
    <Box
      height="52px"
      bg="brown.100"
      borderRadius="xl"
      pl={3}
      pr={1}
      borderWidth={1}
      borderColor="brown.400"
      display="flex"
      alignItems="center"
      gap={3}
      pos="relative">
      <VeniceIcon color="accent.500" />
      <Box
        as="input"
        placeholder={placeholder}
        value={inputValue}
        onChange={e => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        w="100%"
        _placeholder={{ color: 'brown.700' }}
        height="100%"
        bg="transparent"
        border="none"
        color="brown.900"
        outline="none"
      />
      <Box as="button" w="52px" h="52px" outline="none" onClick={handleRedirect}>
        <InputIcon color="#BFB8AD" />
      </Box>
    </Box>
  );
};
